import style from './CardView.module.scss';

type Props = {
  children: React.ReactNode;
  align?: 'start' | 'center';
  cardClassName?: string;
};

const CardView = ({ children, align = 'start', cardClassName }: Props) => {
  return (
    <>
      <div className={`${style.section}  ${cardClassName}`} style={{ textAlign: align }}>
        {children}
      </div>
    </>
  );
};

export default CardView;
